import { createSlice } from "@reduxjs/toolkit";
import { getCustomerLedger } from "../reduxApi/customerLedgerReduxApi";



const customerLedgerSlice = createSlice({
    name: 'customerLedger',
    initialState: {
        status: 'idel',
        isFiltered: false,
        customerLedger: [],
    },
    reducers: {
         setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteCustomerLedgerAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.customerLedger.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.customerLedger.splice(index, 1);
                }
            });
        },
        updateCustomerLedgerAction: (state, action) => {
            // console.log("action", action.payload)
            const index = state.customerLedger.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.customerLedger.splice(index, 1, { customerLedger: action.payload })
            }
        },
        addCustomerLedgerAction: (state, action) => {
            const temp = action.payload.formData;
            console.log("temp",temp);
            
            temp.ROWID = action.payload.ROWID;
            state.customerLedger.unshift( temp);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getCustomerLedger.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getCustomerLedger.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.customerLedger = action.payload.data.data;
                console.log("action.payload.data.response", action.payload.data)
            })
    }
})
export const { deleteCustomerLedgerAction, updateCustomerLedgerAction, addCustomerLedgerAction,setFilteredStatus } = customerLedgerSlice.actions
export default customerLedgerSlice.reducer